module.exports = __webpack_public_path__ + "img/empty_cart_small.117d0779.png";